function assertEvent(_event, _types) {}
function invariantEvent(event, types) {
  types = Array.isArray(types) ? types : [types];

  if (!types.includes(event.type)) {
    throw new Error(`Expected event${types.length > 1 ? 's' : ''} "${types.join(', ')}" but got "${event.type}".`);
  }
}
function isEvent(event, types) {
  types = Array.isArray(types) ? types : [types];
  return types.includes(event.type);
}

export { assertEvent, invariantEvent, isEvent };
